<template functional>
  <div
    :class="['MenuLink', data.class, data.staticClass]"
    v-on="listeners">
    <Route
      v-if="props.link.to"
      :key="props.link.label"
      :exact="$options.isExact(props.link)"
      :to="props.link.to"
      @click.native="listeners['routeClick'] || null">
      <Icon v-if="props.link.icon" :name="props.link.icon" />
      <span class="label">
        {{ props.link.label }}
      </span>
    </Route>
    <a
      v-if="props.link.href"
      :key="props.link.label"
      :href="props.link.href"
      :tabindex="props.index + 2">
      {{ props.link.label }}
    </a>
  </div>
</template>

<script>
export default {
  props: {
    index: Number,
    link: Object,
  },
  isExact({ isExact, children = [] }) {
    return typeof isExact === 'undefined'
      ? !!children.length
      : isExact
  },
}
</script>

<style lang="scss">
.MenuLink {
  border-right: 1px solid $white;
  display: inline-block;
  line-height: $lh;
  padding: 0 1rem;

  a {
    border-bottom: 0;
    color: $white;

    &:hover,
    &:focus {
      color: $white;
      text-shadow: 0 0 2px $white;
    }

    &.router-link-active {
      font-weight: $semibold;
      text-shadow: none;
    }
  }

  &.last {
    border-right: 0;
  }
}
</style>
